import { type QueryOptions } from '@tanstack/query-core'

import { type PageEntity, type MonthlyCustomerReportExEntity } from '@/libs/api'

import {
  type FetchMonthlyCustomerReportQuery,
  fetchMonthlyCustomerReport
} from '../api'
import { monthlyCustomerReportsQueryKeys } from '../query-keys'

/**
 * 月次請求レポート詳細のQueryOptionsを返す
 */
export const getMonthlyCustomerReportQueryOptions = (
  query: FetchMonthlyCustomerReportQuery
): Required<
  Pick<
    QueryOptions<MonthlyCustomerReportExEntity, PageEntity>,
    'queryKey' | 'queryFn'
  >
> => {
  return {
    queryKey: monthlyCustomerReportsQueryKeys.detail(query),
    queryFn: async ({ signal }) => fetchMonthlyCustomerReport(query, signal)
  }
}
